import {
    POST,
    postFile,
    GET,
} from "../../index";
export const selectAllDriver = (param) => POST("/v1/driver/selectAllDriver", param);
export const insertDriver = (param) => POST("/v1/driver/insertDriver", param);
export const updateDriver = (param) => POST("/v1/driver/updateDriver", param);
export const deleteDriver = (param) => POST("/v1/driver/deleteDriver", param);
export const batchTransferDriver = (param) => POST("/v1/driver/batchTransferDriver", param);
export const uploadDriver = (param) => postFile("/v1/getExportExcel/uploadDriver", param);
// 下载模板
export const downLoadTemplateFile = () => GET("/v1/getExportExcel/exportDriverModel")
// 下载附件(没有用到)
export const downLoadFile = (params) => GET('/v1/FileController/getFile')
// 导出车辆信息
export const exportCarData = (params) => GET('/v1/getExportExcel/exportDriver', params)
export const updateDriverNum = (param) => POST("/v1/driver/updateDriverNum", param);
export const updateDriverUser = (param) => POST("/v1/driver/updateDriverUser", param);

export const driverPush = (param) => POST("/v1/driver/driverPush", param);